import { useContext } from 'react';
import ProductPageContext from '../contexts/ProductPageContext';
import BrowserContext from '../contexts/BrowserContext';
import useUserState from '../tools/UserState/useUserState';

/**
 * Custom hook that determines if a user should see member early access UI
 * This occurs when:
 * - User is in a browser environment
 * - User is in a loyalty region
 * - Product has early access
 * - User is not logged in
 *
 * When true, the UI should show member early access components instead of normal add to bag
 *
 * @returns {boolean} - True if user should see member early access UI, false otherwise
 */
const useMemberEarlyAccessCheck = () => {
  const ProductPageState = useContext(ProductPageContext);
  const isBrowser = useContext(BrowserContext);
  const { collectionData, storeId } = ProductPageState;
  const { isLoggedIn } = useUserState(storeId);

  // Check if user should see member early access UI
  // This happens when user is in browser, loyalty region, product has early access, but user is not logged in
  return isBrowser
        && collectionData?.isLoyaltyRegion
        && collectionData?.activeProduct?.isEarlyAccess
    ? !isLoggedIn()
    : false;
};

export default useMemberEarlyAccessCheck;
